interface BaseRowData {
  firstname: string;
  lastname: string;
}
interface RowData extends BaseRowData {
  subRows?: Array<RowData>;
  customSubRows?: Array<RowData>;
}

export const data: Array<RowData> = [
  {
    firstname: 'Firstname Row 0',
    lastname: 'Lastname Row 0',
    subRows: [
      {
        firstname: 'Firstname Row 0.0',
        lastname: 'Lastname Row 0.0',
        subRows: [
          {
            firstname: 'Firstname Row 0.0.0',
            lastname: 'Lastname Row 0.0.0',
          },
          {
            firstname: 'Firstname Row 0.0.1',
            lastname: 'Lastname Row 0.0.1',
          },
        ],
      },
      {
        firstname: 'Firstname Row 0.1',
        lastname: 'Lastname Row 0.1',
        subRows: [
          {
            firstname: 'Firstname Row 0.1.0',
            lastname: 'Lastname Row 0.1.0',
          },
          {
            firstname: 'Firstname Row 0.1.1',
            lastname: 'Lastname Row 0.1.1',
          },
        ],
      },
    ],
  },
  { firstname: 'Firstname Row 1', lastname: 'Lastname Row 1' },
  {
    firstname: 'Firstname Row 2',
    lastname: 'Lastname Row 2',
    subRows: [
      {
        firstname: 'Firstname Row 2.0',
        lastname: 'Lastname Row 2.0',
        subRows: [
          {
            firstname: 'Firstname Row 2.0.0',
            lastname: 'Lastname Row 2.0.0',
          },
          {
            firstname: 'Firstname Row 2.0.1',
            lastname: 'Lastname Row 2.0.1',
          },
        ],
      },
    ],
  },
  {
    firstname: 'Firstname Row 3',
    lastname: 'Lastname Row 3',
    customSubRows: [
      {
        firstname: 'Firstname Row 3.0',
        lastname: 'Lastname Row 3.0',
        customSubRows: [
          {
            firstname: 'Firstname Row 3.0.0',
            lastname: 'Lastname Row 3.0.0',
          },
          {
            firstname: 'Firstname Row 3.0.1',
            lastname: 'Lastname Row 3.0.1',
          },
        ],
      },
      {
        firstname: 'Firstname Row 3.1',
        lastname: 'Lastname Row 3.1',
        customSubRows: [
          {
            firstname: 'Firstname Row 3.1.0',
            lastname: 'Lastname Row 3.1.0',
          },
          {
            firstname: 'Firstname Row 3.1.1',
            lastname: 'Lastname Row 3.1.1',
          },
        ],
      },
    ],
  },
];
